export default "__VITE_ASSET__9ae12f09__"